import * as z from 'zod';
import { allChangeActivityReasons } from '../_const/trip/ChangeActivityReason.ts';
import ChangeActivityReason from '../_const/trip/ChangeActivityReason.ts';

export const MAX_CHANGE_COMMENT_LENGTH = 500;

export const changeActivityBaseSchema = z.object({
  reason: z.enum(allChangeActivityReasons, { required_error: 'Please select a reason' }),
  comment: z
    .string()
    .trim()
    .max(MAX_CHANGE_COMMENT_LENGTH, { message: `Please keep it under ${MAX_CHANGE_COMMENT_LENGTH} characters` })
    .optional(),
});

export const requireCommentForSomethingElse = (
  data: { reason: string; comment?: string },
  ctx: z.RefinementCtx
): void => {
  if (data.reason === ChangeActivityReason.SOMETHING_ELSE && !data.comment) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Please provide a comment',
      path: ['comment'],
    });
  }
};

export const changeActivityRequestSchema = changeActivityBaseSchema.superRefine(requireCommentForSomethingElse);

export type ChangeActivityRequest = z.infer<typeof changeActivityRequestSchema>;
